// @flow
import {
  Duration,
} from 'luxon';

// convert JIRA time (e.g 1d 1h 20m) to seconds
export function jts(jiraTimeString: string): number {
  const jiraTimeArray = jiraTimeString.split(' ');
  let resultSeconds = 0;
  jiraTimeArray.forEach((unit) => {
    const value = Number(unit.slice(0, -1));
    const postfix = unit[unit.length - 1];
    switch (postfix) {
      case 'd':
        resultSeconds += value * 86400;
        break;
      case 'h':
        resultSeconds += value * 3600;
        break;
      case 's':
        resultSeconds += value;
        break;
      case 'm':
      default:
        resultSeconds += value * 60;
        break;
    }
  });
  return resultSeconds;
}

// convert seconds to JIRA time (e.g 10h 30m) using given format
export function stj(seconds: number, format: string = 'h\'h\' m\'m\''): string {
  let finalFormat = format;
  const duration = Duration.fromMillis(seconds * 1000);
  if (seconds <= 3540) {
    finalFormat = 'm\'m\'';
  }
  return duration.toFormat(finalFormat);
}
